import { Component, Signal, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatListItem, MatListItemIcon, MatListItemLine, MatListItemMeta, MatListItemTitle, MatNavList } from '@angular/material/list';
import { IconComponent } from '@libs/components/icons';
import { NavItemModel } from '@libs/shared/models';
import { NavigationService } from '@libs/shared/services';
import { NavLinkDirective } from '@libs/shared/ui';

@Component({
  selector: 'ui-order-manager',
  templateUrl: './order-manager.component.html',
  styleUrls: ['./order-manager.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatNavList,
    MatListItem,
    MatListItemIcon,
    MatListItemLine,
    MatListItemMeta,
    MatListItemTitle,
    NavLinkDirective,
    IconComponent,
  ],
})
export class OrderManagerComponent {
  public nav: Signal<NavItemModel | undefined> = toSignal(this.navigationService.getOrdersNavigation());

  public constructor(
    private readonly navigationService: NavigationService,
  ) {
  }

  public close(): Promise<boolean | void> {
    return this.navigationService.closeOverlayRoute();
  }
}
